<template>
    <v-dialog
        v-model="dialog"
        fullscreen
    >
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title>Search Previously Uploaded Attachments</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="onClickDiscardChanges"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        dark
                        text
                        @click="onClickSave"
                    >
                        Attach Files
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
                <v-text-field
                    v-model="full_text"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    style="margin-bottom: 15px;"
                    autocomplete="off"
                />

                <!-- Switch for non-system admins -->
                <v-switch
                    v-if="!$rc.$state.isSystemsAdmin()"
                    label="Include All RedChirp User"
                    v-model="include_all_team_members"
                    style="margin-right: 15px"
                    v-on:change="doSearch"
                />

                <!-- Message for system admins/staff -->
                <v-alert type="info" dense v-if="$rc.$state.isSystemsAdmin()">
                    As a staff member, you always see attachments from all team members.
                </v-alert>

                <v-data-table
                    :headers="headers"
                    :items="results"
                    :items-per-page="100"
                    class="elevation-1"

                    hide-default-footer
                >
                    <template
                        v-slot:item.selected="{ item }"
                        v-ripple="false"
                    >
                        <v-simple-checkbox
                            v-on:input="toggleIsSelected(item)"
                            v-model="item.is_selected"
                        >
                            {{isSelected(item)}}
                        </v-simple-checkbox>
                    </template>

                    <template v-slot:item.pretty_size_in_bites="{ item }">
                        {{prettySizeInBites(item)}}
                    </template>

                    <template v-slot:item.pretty_uploaded_time="{ item }">
                        {{prettyUploadedTime(item)}}
                    </template>

                    <template v-slot:item.create_hyperlink="{ item }">
                        <a
                            :href="createHyperlink(item)"
                            target="_blank"
                        >
                            {{item.label}}
                        </a>
                    </template>

                </v-data-table>

            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>

const Time = require('@/js/time.js');

export default {

    data() {
        return {
            dialog: false,
            is_valid: true,
            full_text: '',
            include_all_team_members: false,

            selected_ids: [],
            results: [],
            headers: [
                { text: 'Selected', value: 'selected' },
                { text: 'File', value: 'label' },
                { text: 'By', value: 'uploaded_by_employee_label' },
                { text: 'Size', value: 'pretty_size_in_bites' },
                { text: 'Uploaded', value: 'pretty_uploaded_time' },
                { text: 'View', value: 'create_hyperlink' },
            ],
            byte_sizes: ['Bytes', 'KB', 'MB', 'GB'],
        }
    },

    mounted () {
        this.doSearch();
    },

    methods: {
        prettySizeInBites(item)
        {
            let bytes = item.size_in_bytes;

            if (bytes == 0) return '0 Byte';
            let idx = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, idx), 2) + ' ' + this.byte_sizes[idx];
        },

        prettyUploadedTime(item)
        {
            return Time.getTimeAndDate(item.uploaded_time);
        },

        createHyperlink(item)
        {
            return this.$rc.blobURL(item.object_name);
        },

        toggleIsSelected(item)
        {
            if (this.selected_ids.includes(item.blob_id))
            {
                for (let i= 0; i < this.selected_ids.length; i++)
                {
                    if (this.selected_ids[i] == item.blob_id)
                    {
                        this.selected_ids.splice(i,1);
                    }
                }

                item.is_selected = false;
            }
            else
            {
                this.selected_ids.push(item.blob_id);
                item.is_selected = true;
            }
        },

        isSelected(item)
        {
            return this.selected_ids.includes(item.blob_id);
        },

        doSearch()
        {
            let search = {
                'full_text' : this.full_text,
                'organization_id' : this.$rc.$state.organization_id,
                'uploaded_by_employee_id' : this.$rc.$state.profile.employee_account.employee_id,
                'limit' : 1000,
            };

            if (this.include_all_team_members || this.$rc.$state.isSystemsAdmin())
            {
                search.uploaded_by_employee_id = null;
            }

            this.$rc.showSpinner();

            this.$rc.searchBlobMetaDataSummaries(
                search,

                (data) => {
                    this.$rc.hideSpinner();
                    this.results = data.results;
                    this.setSelectedStatus();
                },

                () => {
                    this.$rc.hideSpinner();
                }
            );
        },

        setSelectedStatus()
        {
            for (let i=0; i < this.results.length; i++)
            {
                if (this.isSelected(this.results[i]))
                {
                    this.results[i].is_selected = true;
                }
            }
        },

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // The dialog is showing...
            if ( this.is_valid )
            {
                // data is valid, so save
                this.save();
                this.dialog = false;
                next();
                return;
            }

            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        save()
        {
            // save the attachments to the previous screen
            this.$emit('on-attach-files',this.selected_ids);
        },
    },
    watch: {
        full_text(newValue, oldValue) {
            this.doSearch();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>